<template>
    <div
        class="md-team layout1 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            ...bgImgStyle
        }"
    >
        <div :fullColumn="fullColumn || isMobileSize">
            <div class="module-header f-col">
                <site-title
                    :title="fmtTitle"
                ></site-title>
                <div
                    class="arrow"
                    v-if="agents.length > useSlidesPerView && !isMobileSize"
                >
                    <i class="iconfont icon-arrow-up prev-el"></i>
                    <i class="split"></i>
                    <i class="iconfont icon-arrow-up next-el"></i>
                </div>
            </div>
            <swiper
                v-bind="options"
                v-if="agents.length"
                :class="{ ['len-' + agents.length]: true, 'f-col': !isMobileSize }"
            >
                <slide v-for="(agent, index) in agents" :key="index">
                    <AgentCard
                        :agent="agent"
                        :detailUrlTarget="detailUrlTarget"
                        :theme="theme"
                    />
                </slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import common from '../index-layout.js';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import AgentCard from './agent-card.vue';
import carousel from '../carousel';
export default {
    mixins: [common, carousel],
    components: {
        AgentCard
    },
    data: function() {
        return {
            imageStyle: {},
            containerStyle: {},
            slidesPerView: 4,
            mobileSlidesPerView: 1.7
        };
    },
    computed: {
        ...mapState(usePageStore, {
            company: store => store.companyInfo
        }),
        isMobile() {
            return this.platform.isMobile;
        }
    },
    methods: {}
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.layout1 {
    line-height: 1.5;
    .module-header {
        min-height: 50px;
        position: relative;
        margin-bottom: 20px;
        .arrow {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            color: var(--g-primary-color);
            .prev-el {
                font-size: 20px;
                display: inline-block;
                transform: rotate(-90deg);
            }
            .next-el {
                font-size: 20px;
                display: inline-block;
                transform: rotate(90deg);
            }
            .split {
                display: inline-block;
                width: 52px;
            }
        }
    }
    .swiper-wrapper {
        .swiper-slide {
            width: 320px;
            height: fit-content;
        }
    }
    .len-1,
    .len-2,
    .len-3 {
        .swiper-wrapper {
            justify-content: center;
        }
    }
    @include media-800 {
        .swiper-wrapper {
            .swiper-slide {
                &:first-child {
                    margin-left: 20px;
                }
            }
        }
    }
    @include media-600 {
        .swiper-wrapper {
            .swiper-slide {
                width: 200px;
                &:first-child {
                    margin-left: 15px;
                }
            }
        }
        .len-1 {
           .swiper-wrapper {
                .swiper-slide {
                    &:first-child {
                        margin-left: 0;
                        margin-right: 0 !important;
                    }
                }
            } 
        }
        .len-2,
        .len-3 {
            .swiper-wrapper {
                justify-content: flex-start;
            }
        }
    }
}
</style>
